import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Device } from '@capacitor/device';
@Directive({
  selector: '[appSafeArea]',
  standalone:false
})
export class SafeAreaDirective implements OnInit {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  async ngOnInit() {
    const info = await Device.getInfo();
    if(info.platform!="web"){
      await this.applySafeAreaPadding();
    }
  }

  private async applySafeAreaPadding() {
    try {
        await StatusBar.setStyle({ style: Style.Light });
        await StatusBar.show();

        const statusBarDiv = document.createElement('div');
        statusBarDiv.style.position = 'fixed';
        statusBarDiv.style.top = '0';
        statusBarDiv.style.width = '100%';
        statusBarDiv.style.height = 'env(safe-area-inset-top)';
        statusBarDiv.style.pointerEvents = 'none';
        document.body.appendChild(statusBarDiv);

        setTimeout(() => {
          const height = getComputedStyle(statusBarDiv).height;
          this.renderer.setStyle(this.el.nativeElement, 'padding-top', '85px');
          document.body.removeChild(statusBarDiv);
        }, 100);
    } catch (error) {
    }
  }
}
